export const showManufacturerLogo = (
  manufacturerLogoUrl: string | undefined,
  isOptime: boolean
): manufacturerLogoUrl is string => !!manufacturerLogoUrl && !isOptime;
